// Today's brief is wanted by more than one thing on a page as the app boots:
// the front page itself, the stay page's conditions snapshot, and the harbor
// chart behind every page, which keeps the day's tide and wind. One request
// serves them all. It is kept for a minute, so a page opened after the
// morning publish still gets the new brief; a failure is not kept at all.
let live = null;

export function fetchBrief(path = '/api/get-brief') {
  if (path !== '/api/get-brief') return load(path);
  const now = Date.now();
  if (!live || now - live.at > 60000) {
    const promise = load(path);
    live = { at: now, promise };
    promise.catch(() => {
      if (live?.promise === promise) live = null;
    });
  }
  return live.promise;
}

async function load(path) {
  const res = await fetch(path, { cache: 'no-cache' });
  if (res.ok) return res.json();
  if (path === '/api/get-brief') {
    const fallback = await fetch('/data/brief.json', { cache: 'no-cache' });
    if (fallback.ok) return fallback.json();
  }
  // The status rides on the error rather than in its message: a guest should
  // never read "(404)", but the caller has to tell a date with no brief from a
  // server that is down, because those are different pages.
  const err = new Error("We couldn't load the brief.");
  err.status = res.status;
  throw err;
}

export function selectPersonaContent(brief, personaId) {
  if (!brief?.personas) return null;
  return brief.personas[personaId] || brief.personas.everyone || null;
}
